module.exports = __webpack_public_path__ + "static/img/sm.e7c3360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/sy/sm.png
// module id = crbN
// module chunks = 0